// Libraries
import React, { LegacyRef, useRef } from "react";
import { useObserver, useEffect } from "@shoothill/core";

// Custom

// Components
import AdminApplicantViewModel from "Globals/ViewModels/Applicant/AdminApplicantViewModel";

// Styling & images
import { Box, Modal } from "@material-ui/core";
import styled from "styled-components";
import PaymentViewModel from "Globals/ViewModels/Payment/PaymentViewModel";
// TODO Move styles to separate file
// TODO implement theme colors instead of hardcoded hex values
export const ModalBase: any = styled(Modal)`
    padding: 0px;
    margin: 10% auto;
    flex-direction: column;
    display: flex;
    max-width: 400px;

    .modalhead,
    .modalbody {
        padding: 10px 15px;
        background-color: rgba(255, 255, 255, 1);
        outline: none;
    }

    .modalhead {
        border-radius: 5px 5px 0px 0px;
        background-color: #84bb25;
        color: white;

        h2 {
            margin: 0 auto;
            font-size: 1.8em;
            text-transform: uppercase;
            font-weight: 500;
        }
    }
    .modalbody {
        border-radius: 0px 0px 5px 5px;
        background-color: rgba(255, 255, 255, 1);
        outline: none;
    }
    ul {
        list-style: none;
        padding: 0;
        margin: 0;
    }

    li {
        padding-left: 1em;
        text-indent: -0.7em;
        font-size: 12px;
    }

    li::before {
        content: "•";
        padding-right: 7px;
        color: #19bb00;
    }
`;
export const ModelButtonsContainer = styled(Box)`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-top: 20px;

    button {
        border-radius: 0px;
        display: flex;
        flex: 1 50%;
        color: white;
        font-size: 12px;
        background-color: #3c3c3b;
    }
    button:first-child {
        background-color: #19bb00;
    }
`;

interface IProps {
    isActive: boolean;
    paymentViewModel: PaymentViewModel;
    adminApplicantViewModel: AdminApplicantViewModel;
    confirmClose(confirm: boolean): void;
    onCancel(): void;
}

export const PaymentModal: React.FC<IProps> = (props) => {
    const ref: LegacyRef<HTMLFormElement> = useRef(null);

    useEffect(() => {
        ref.current?.submit();
    }, [props.paymentViewModel.allPayToken]);

    useEffect(() => {
        if (!props.isActive || !props.paymentViewModel.allPayToken) return;

        let intervalId: ReturnType<typeof setInterval>;

        const checkForFinishButton = () => {
            const iframe = document.getElementById("PaymentIFrame") as HTMLIFrameElement | null;
            if (!iframe?.contentWindow) return;

            try {
                const finishButton = iframe.contentWindow.document.getElementById("finishButton");
                if (finishButton) {
                    finishButton.click();
                    props.onCancel();
                    clearInterval(intervalId);
                }
            } catch {
                console.log("payment modal error");
                // Cross-origin: cannot access iframe content
            }
        };

        intervalId = setInterval(checkForFinishButton, 1000);

        return () => clearInterval(intervalId);
    }, [props.isActive, props.paymentViewModel.allPayToken, props.onCancel]);

    return useObserver(() => (
        <>
            <ModalBase open={props.isActive} onClose={() => props.onCancel()}>
                <div>
                    <div className="modalbody">
                        {props.paymentViewModel.allPayToken && (
                            <>
                                <form id="IFrameForm" method="post" target="PaymentIFrame" action={props.paymentViewModel.allPayBaseUrl} ref={ref} style={{ display: "none" }}>
                                    <input type="hidden" name="CustomerReference" value={props.adminApplicantViewModel.model.surname} />
                                    <input type="hidden" name="Amount" value="500.00" />
                                    <input type="hidden" name="PaymentReason" value="SO Reservation Fee" />
                                    <input type="hidden" name="ClientCode" value="HTOT" />
                                    <input type="hidden" name="Token" value={props.paymentViewModel.allPayToken} />
                                </form>
                                <iframe
                                    name="PaymentIFrame"
                                    id="PaymentIFrame"
                                    style={{ height: "66vh", width: "100%", maxWidth: "90vw", paddingTop: "20px" }}
                                    title="Payment IFrame"
                                />
                            </>
                        )}
                    </div>
                </div>
            </ModalBase>
        </>
    ));
};
